<template>
  <div>
    <div
      class="help-details career-search"
      :style="{ backgroundImage: termsConditions.banner_image ? `url(${termsConditions.banner_image})`:'url(/img/bg.jpg)' }"
    >
      <div class="container">
        <div class="row help-search">
          <div class="col-12 margin-tb">
            <div>
              <h2 class="mb-0">
                {{
                  domainBasedBrand
                    ? _T_DB(currentBrand, 'name')
                    : _T('Go Order')
                }}
                {{ _T_DB(termsConditions,'page_title') }}
              </h2>
            </div>
          </div>
          <div class="effective-on"> {{ _T('Last updated on') }}: {{_T('May 24, 2020')}} </div>
        </div>
      </div>
    </div>
    <section class="section-b-space">
      <div class="container">
        <div class="row d-none d-sm-block">
          <div class="col-sm-12">
            <div class="help-title">
              <h2>{{ _T_DB(termsConditions, 'content_heading') }}</h2>
              <br>
            </div>
          </div>
        </div>
          <div v-html="_T_DB(termsConditions,'content')"></div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'StaticTermsAndConditions',
  data() {
    return {
      backgroundImage: '/img/bg.jpg',
    }
  },
  computed: {
    ...mapGetters(['_T', 'domainBasedBrand', '_T_DB', 'currentBrand','all_static_pages']),
    termsConditions() {
      if (this.all_static_pages) {
        return this.all_static_pages.find(page => page.slug === 'terms-condition')
      }
      return {}
    },
  },
  // privacy-policy
}
</script>

<style lang="scss" scoped>
.help-details {
  color: $white;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  .margin-tb{
    margin-bottom: 6rem;
    margin-top: 12rem;
  }
  .effective-on {
    padding: 1rem;
    text-align: right;
    width: 100%;
  }
}
</style>
